import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 72,
    paddingBottom: 56,
    paddingHorizontal: 48,
    fontSize: 11,
    fontFamily: 'Helvetica',
    color: '#111827',
  },
  coverPage: {
    paddingTop: 96,
    paddingBottom: 72,
    paddingHorizontal: 56,
    fontSize: 12,
    color: '#0f172a',
  },
  header: {
    position: 'absolute',
    top: 24,
    left: 48,
    right: 48,
  },
  footer: {
    position: 'absolute',
    bottom: 18,
    left: 48,
    right: 48,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerSubtitle: {
    marginTop: 6,
    textAlign: 'center',
    fontSize: 10,
    color: '#475569',
  },
  footerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 9,
    color: '#475569',
  },
  logoSmall: {
    height: 24,
    width: 72,
    objectFit: 'contain',
  },
  logoLarge: {
    height: 56,
    width: 140,
    objectFit: 'contain',
  },
  coverLogos: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 48,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 12,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 700,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 600,
    marginBottom: 8,
  },
  text: {
    fontSize: 11,
    lineHeight: 1.4,
  },
  mutedText: {
    color: '#64748b',
  },
  smallText: {
    fontSize: 9,
    color: '#64748b',
  },
  block: {
    marginBottom: 16,
  },
  box: {
    borderWidth: 1,
    borderColor: '#e2e8f0',
    padding: 12,
    borderRadius: 6,
  },
  listItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  bullet: {
    width: 10,
    fontSize: 11,
  },
  table: {
    borderWidth: 1,
    borderColor: '#e2e8f0',
    borderRadius: 6,
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e2e8f0',
  },
  tableCellLabel: {
    width: '40%',
    padding: 6,
    backgroundColor: '#f8fafc',
    fontSize: 10,
    fontWeight: 600,
  },
  tableCellValue: {
    width: '60%',
    padding: 6,
    fontSize: 10,
  },
  tableRowLast: {
    borderBottomWidth: 0,
  },
});
